export const UPDATE_IMAGES_CACHE = 'UPDATE_IMAGES_CACHE';
export const CLEAR_IMAGES_CACHE = 'CLEAR_IMAGES_CACHE';

export const updateImagesCache = (imagesMap, thumbnails) => ({ type: UPDATE_IMAGES_CACHE, imagesMap, thumbnails });
export const clearImagesCache = () => ({ type: CLEAR_IMAGES_CACHE });
